// ./client/src/components/admin/VoipServices.js
import React, { useState } from "react";
import { useAppContext } from "../../context/appContext";
import { Display1 } from "../workspace";

const VoipServices = () => {
  const { defaults, handleChange, sendTestText, isLoading } = useAppContext();

  const [results, setResults] = useState();

  const basicTest = async () => {
    const rawReturn = await sendTestText();
    const rawResults = rawReturn.data.testMessageSent;
    const testResults = JSON.stringify(rawResults, null, 2);
    console.log("testResults:", testResults);
    setResults(testResults);
  };

  const clearResults = () => {
    setResults("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <div className="group whole">
      <form onSubmit={handleSubmit} className="form">
        <h3>Texting Control Panel</h3>
        {/* --- Test Buttons --- */}
        <div className="form-center">
          <div className="one-third">
            <button
              className="btn btn-block"
              type="button"
              disabled={isLoading}
              onClick={basicTest}
            >
              Basic SMS Tests
            </button>
          </div>
          <div className="one-third">
            <button
              className="btn red btn-block"
              type="button"
              disabled={isLoading}
              onClick={clearResults}
            >
              Clear Results
            </button>
          </div>
        </div>
        {/* --- Display Results --- */}
        <div className="form-center">
          <Display1 name="sms-results" label="SMS Test Results" value={results} />
        </div>
      </form>
    </div>
  );
};
export default VoipServices;
